module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/15f09e3f515e2dfc17fd73c5d65441fa.png";